document.addEventListener('DOMContentLoaded',function(){
  var announcementSlider = new Swiper('.Custom-announcementSlider.swiper', {
    loop: true,
    slidesPerView: 1
  })
  


  var productSlackSlider = new Swiper('.JPS_PD-SlkLst.no-tab-section.make-it-colorless.swiper.mySwiper',{
    slidesPerView: 3,
    spaceBetween: 22,
    navigation : {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      991: { slidesPerView: 3 },
      749: { slidesPerView: 2 },
      0: { slidesPerView: 1 }
    }
  })

  var productSlackSliderClor = new Swiper('.JPS_PD-SlkLst.make-it-colored-section.swiper.mySwiper',{
    slidesPerView: 3,
    spaceBetween: 22,
    navigation : {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      991: { slidesPerView: 3 },
      749: { slidesPerView: 2 },
      0: { slidesPerView: 1.41 }
    }
  })
  
  var indexReviwesSlider = new Swiper('.JPS_CUSTREV-Items.swiper.mySwiper',{
    loop : true,
    centeredSlides: true,
    spaceBetween: 24,
    navigation : {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1440: { slidesPerView: 3.15 },
      749: { slidesPerView: 2.39 },
      0 : { slidesPerView: 1.28, centeredSlides: false }
    }
  })

  var indexVDOSlider = new Swiper('.JPS_VDO-Wrapper.swiper.mySwiper',{
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  })
  
  var watchBuySlider = new Swiper('.JPS_WACHBuyLooper.swiper.mySwiper',{
    slidesPerView: 4,
    spaceBetween: 23,
    navigation : {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      1024: { slidesPerView: 4 },
      991: { slidesPerView: 3 },
      749: { slidesPerView: 2 },
      0 : { slidesPerView: 1.3 }
    }
  })

  var blogSlackSlider = new Swiper('.blgMultiArtWrapr.onlyShowMob.swiper.mySwiper',{
    slidesPerView: 1.3,
    spaceBetween: 16,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  })
})